/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ product: NonNullable<unknown>, mode: NonNullable<unknown> }} Tl_LabelInputs */

const en_tl_label = /** @type {(inputs: Tl_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.product} timeline, ${i?.mode}`)
};

const de_tl_label = /** @type {(inputs: Tl_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zeitleiste ${i?.product}, ${i?.mode}`)
};

/**
* | output |
* | --- |
* | "{product} timeline, {mode}" |
*
* @param {Tl_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_label = /** @type {((inputs: Tl_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_label(inputs)
	return en_tl_label(inputs)
});